// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"201":"3e7e67dc","369":"dbe1be0e","985":"0d22bce8"}[chunkId] + ".chunk.css";
};